import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=9b38aecc&scoped=true&"
import script from "./Discipline.vue?vue&type=script&lang=js&"
export * from "./Discipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38aecc",
  null
  
)

export default component.exports